var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((5),function(item){return _c('v-row',{key:item},[_c('v-col',{staticClass:"skeleton",attrs:{"cols":"5"}}),_c('v-col',{staticClass:"skeleton",attrs:{"cols":"3"}}),_c('v-col',{staticClass:"skeleton",attrs:{"cols":"2"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }